import React, { useEffect } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import { adicionarPontosMilhar } from "../utils/adicionarPontosMilhar";
import { useState } from "react";
import { montarGraficoStackedColumn } from "../common/graficos/montarGraficoStackedColumn";
import { LoadingIcon } from "../common/loadingIcon/LoadingIcon";

export function GraficoAproveitamentoUsina({ id, periodo, item }) {
    let lista = [];
    let descricao = "";
    let nomePeriodo = "";
    let paddingLeft = 0;
    let gap = 0;
    if (periodo === "mes") {
        gap = 30;
        paddingLeft = 55;
        nomePeriodo = "MÊS";
        if (item.unidade_geradora) {
            const totalStack = parseFloat(item.consumo_instantaneo) + parseFloat(item.quantidade_economia) + parseFloat(item.quantidade_economia_remotas);
            lista = [
                { value: item.quantidade_geracao, category: "Produziu", stacked: false },
                { value: item.energia_excedente, category: "Injetou na Rede", stacked: false },
                { value: item.quantidade_economia_remotas, category: "Creditado na Fatura das Remotas", stacked: false },
                { value: item.quantidade_economia, category: "Creditado na Fatura da Geradora", stacked: true },
                { value: item.consumo_instantaneo, category: "Creditado Instantaneamente na Geradora", stacked: true, totalStack },
            ];
            const percentual = (item.quantidade_geracao || 0) > 0 ? ((totalStack || 0) * 100) / (item.quantidade_geracao || 0) : 0;
            descricao = `Distribuiu ${adicionarPontosMilhar((percentual || 0).toFixed(2))}% em ${String(item.competencia).substring(4, 6)}/${String(item.competencia).substring(
                0,
                4
            )}`;
        } else if (item.unidade_remota) {
            lista = [
                { value: item.quantidade_geracao_fonte_geradora, category: "Produção Usina Fonte", stacked: false },
                { value: item.energia_excedente_fonte_geradora, category: "Injetada na Rede pela Fonte", stacked: false },
                { value: item.quantidade_economia, category: "Creditado nesta UC", stacked: false },
            ];
            const percentual = (item.quantidade_geracao_fonte_geradora || 0) > 0 ? ((item.quantidade_economia || 0) * 100) / (item.quantidade_geracao_fonte_geradora || 0) : 0;
            descricao = `Recebeu ${adicionarPontosMilhar((percentual || 0).toFixed(2))}% da Geradora em ${String(item.competencia).substring(4, 6)}/${String(
                item.competencia
            ).substring(0, 4)}`;
        }
    }
    if (periodo === "ano") {
        gap = 28;
        paddingLeft = 66;
        nomePeriodo = "ANO";
        if (item.unidade_geradora) {
            const totalStack = parseFloat(item.consumo_instantaneo_ano) + parseFloat(item.quantidade_economia_ano) + parseFloat(item.quantidade_economia_remotas_ano);
            lista = [
                { value: item.quantidade_geracao_ano, category: "Produziu", stacked: false },
                { value: item.energia_excedente_ano, category: "Injetou na Rede", stacked: false },
                {
                    value: item.quantidade_economia_remotas_ano,
                    category: "Creditado na Fatura das Remotas",
                    stacked: false,
                },
                { value: item.quantidade_economia_ano, category: "Creditado na Fatura da Geradora", stacked: true },
                {
                    value: item.consumo_instantaneo_ano,
                    category: "Creditado Instantaneamente na Geradora",
                    stacked: true,
                    totalStack,
                },
            ];
            const percentual = (item.quantidade_geracao_ano || 0) > 0 ? ((totalStack || 0) * 100) / (item.quantidade_geracao_ano || 0) : 0;
            descricao = `Distribuiu ${adicionarPontosMilhar((percentual || 0).toFixed(2))}% em ${String(item.competencia).substring(0, 4)}`;
        } else if (item.unidade_remota) {
            console.log(item)
            lista = [
                { value: item.quantidade_geracao_ano_fonte_geradora, category: "Produção Usina Fonte", stacked: false },
                {
                    value: item.energia_excedente_ano_fonte_geradora,
                    category: "Injetada na Rede pela Fonte",
                    stacked: false,
                },
                { value: item.quantidade_economia_ano, category: "Creditado nesta UC", stacked: false },
            ];
            const percentual =
                (item.quantidade_geracao_ano_fonte_geradora || 0) > 0                    
                    ? ((item.quantidade_economia_ano || 0) * 100) / (item.quantidade_geracao_ano_fonte_geradora || 0)
                    : 0;
            descricao = `Recebeu ${adicionarPontosMilhar((percentual || 0).toFixed(2))}% da Geradora em ${String(item.competencia).substring(0, 4)}`;
        }
    }

    const [grafico, setGrafico] = useState(null);

    useEffect(() => {
        const dados = [...lista];

        const graficoAtualizado = montarGraficoStackedColumn({
            cores: [am4core.color("#ecb110"), am4core.color("#ff0ca2"), am4core.color("#1cb695"), am4core.color("#0084ff"), am4core.color("#5100ff")],
            component: grafico,
            nome: `grafico-aproveitamento-usina-${id}`,
            dados,
            animacaoAtivada: false,
            fontColor: "#FFF",
        });

        setGrafico(graficoAtualizado);
        return () => {
            if (grafico) grafico.dispose();
        };
    }, [id, periodo, item]);

    return (
        <div style={{ textAlign: "center", backgroundColor: "#202769", padding: 5, margin: 5, borderRadius: 10, boxShadow: "0px 0px 3px 1px #6285ca" }}>
            <div style={{ fontWeight: "bold" }}>{nomePeriodo}</div>
            <div
                id={`grafico-aproveitamento-usina-${id}`}
                style={{
                    width: 300,
                    height: grafico ? 140 : 0,
                    maxHeight: grafico ? 140 : 0,
                    minHeight: grafico ? 140 : 0,
                }}
            />
            {grafico ? (
                <div className="p-2" style={{ fontSize: "0.7rem", fontWeight: "bolder", width: "100%", textAlign: "center" }}>
                    <div className="d-flex justify-content-center" style={{ gap, marginTop: -15, paddingLeft, paddingBottom: 5 }}>
                        <div>Produziu</div>
                        <div>Injetou</div>
                        <div>Creditou</div>
                    </div>
                    <div style={{ padding: 3, borderRadius: 6, backgroundColor: "#009d48" }}>{descricao}</div>
                </div>
            ) : (
                <div style={{ height: 200 }}>
                    <LoadingIcon />
                </div>
            )}
        </div>
    );
}
